/**
 * Hands an in-memory blob to the browser as a named file download — the
 * same anchor-with-object-URL flow the server-side CSV exports use, shared
 * so client-built files (statistics CSV) go through one implementation.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
